import {
  Box,
  Card,
  Chip,
  LinearProgress,
  Tooltip,
  Typography,
  useTheme,
  Checkbox,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  CircularProgress,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { useLocation } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { ColDef } from "ag-grid-community";
import React from "react";
import { useDispatch } from "react-redux";
import { setButtonSelected, setSelectedControlType, setSelectedRowID, setTabSelected } from "./TabSelection-slice";
import axiosInstance from "../../axios/axios";
import { END_POINTS } from "../../shared";
import { toast } from "react-toastify";
import AgGridTable from "../../components/table/AgGridTable";
import Exclamation from "../../assets/Exclamation.png";
import Pencil_Blue from "../../assets/baseVersion/Pencil_Blue.svg";
import cis_light from "../../assets/cis_light.svg";
import nistLogo from "../../assets/nist.svg";
import nist_dark from "../../assets/nist_dark.svg";
import spark_dark from "../../assets/spark_dark.svg";
import cis_dark from "../../assets/cis_dark.svg";
import sparkLogo from "../../assets/Spark-text.svg";
import customTemplateLogo from "../../assets/custom_template_logo.svg";
import Pencil_Light_img from "../../assets/baseVersion/Pencil_Light_img.svg";
import True from "../../assets/baseVersion/True_img.svg";
import False from "../../assets/baseVersion/False_img.svg";
import Not_Applicable from "../../assets/baseVersion/NotApplicable.svg";
import SecurityDetailsDrawer from "./SecurityDetailsDrawer";
import eventEmitter from "../../components/utils/eventEmitter";
import AcceptedRisk_False from "../../assets/baseVersion/AcceptedRisk_False.svg";
import WhiteTooltip from "../../components/WhiteTooltip";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// Custom checkbox filter for 'controls' column (Recommendation)
const ControlsFilter = React.forwardRef<any, any>((params, ref) => {
  const [selected, setSelected] = useState<string[]>([]);
  const [isAll, setIsAll] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const [options, setOptions] = useState<string[]>(
    Array.isArray(params.parameterOptions) ? params.parameterOptions : []
  );

  const filteredOptions = useMemo(() => {
    const opts = options || [];
    if (!searchText.trim()) return opts;
    return opts.filter((o) =>
      o.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [options, searchText]);

  useEffect(() => {
    if (Array.isArray(params.parameterOptions))
      setOptions(params.parameterOptions);
  }, [params.parameterOptions]);

  React.useImperativeHandle(ref, () => ({
    isFilterActive: () => selected.length > 0 && !isAll,
    doesFilterPass: (nodeParams: any) => {
      if (selected.length === 0 || isAll) return true;
      const val = nodeParams.data?.parameter_type;
      if (val == null) return false;
      // Exact match on selected control names
      return selected.includes(String(val));
    },
    getModel: () =>
      selected.length > 0 && !isAll ? { selectedTypes: selected } : null,
    setModel: (model: any) => {
      if (model && model.selectedTypes) {
        setSelected(model.selectedTypes);
        setIsAll(false);
      } else {
        setSelected([]);
        setIsAll(true);
      }
    },
    getGui: () => null,
  }));

  const toggle = (opt: string) => {
    if (opt === "All") {
      setIsAll(true);
      setSelected([]);
    } else {
      setIsAll(false);
      setSelected((prev) =>
        prev.includes(opt) ? prev.filter((o) => o !== opt) : [...prev, opt]
      );
    }
    // @ts-ignore mark modified if available
    if (typeof (params as any).filterModifiedCallback === "function")
      (params as any).filterModifiedCallback();
  };

  const apply = () => {
    console.log("ControlsFilter Apply clicked", { selected, isAll });
    try {
      if (typeof (params as any).onApplyParameterFilter === "function") {
        (params as any).onApplyParameterFilter(selected, isAll);
      }
    } catch {}
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === "function")
      (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const clear = () => {
    setSelected([]);
    setIsAll(true);
    // Inform parent filter handler (if provided) so gridData gets reset — matches TagsFilter/SeverityFilter behavior
    try {
      if (typeof (params as any).onApplyParameterFilter === "function") {
        (params as any).onApplyParameterFilter([], true);
      }
    } catch {}
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === "function")
      (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const isDarkTheme = params.isDarkMode || false;

  return (
    <div
      style={{
        padding: "12px",
        minWidth: "180px",
        backgroundColor: isDarkTheme ? "#2d3748" : "#ffffff",
        border: `1px solid ${isDarkTheme ? "#4a5568" : "#e2e8f0"}`,
        borderRadius: "6px",
        boxShadow: isDarkTheme
          ? "0 4px 6px rgba(0, 0, 0, 0.3)"
          : "0 4px 6px rgba(0, 0, 0, 0.1)",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        fontSize: "13px",
      }}
    >
      <div
        style={{
          marginBottom: "12px",
          fontWeight: 500,
          color: isDarkTheme ? "#f7fafc" : "#2d3748",
          fontSize: "13px",
        }}
      >
        Filter Recommendations
      </div>
      <div style={{ marginBottom: "12px" }}>
        <input
          type="text"
          placeholder="Search..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{
            width: "100%",
            padding: "6px 8px",
            border: `1px solid ${isDarkTheme ? "#4a5568" : "#e2e8f0"}`,
            borderRadius: "4px",
            backgroundColor: isDarkTheme ? "#1a202c" : "#ffffff",
            color: isDarkTheme ? "#f7fafc" : "#2d3748",
            fontSize: "13px",
            outline: "none",
            boxSizing: "border-box",
          }}
        />
      </div>
      <div
        style={{ maxHeight: "220px", overflowY: "auto", marginBottom: "12px" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "6px 8px",
            cursor: "pointer",
            backgroundColor: isAll
              ? isDarkTheme
                ? "#3182ce"
                : "#e2e8f0"
              : "transparent",
            borderRadius: "4px",
            marginBottom: "2px",
          }}
        >
          <Checkbox
            size="small"
            checked={isAll}
            onChange={() => toggle("All")}
          />
          <span style={{ marginLeft: 8 }}>All</span>
        </div>
        {filteredOptions.map((opt) => {
          const checked = !isAll && selected.includes(opt);
          return (
            <div
              key={opt}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "6px 8px",
                cursor: "pointer",
                backgroundColor: checked
                  ? isDarkTheme
                    ? "#3182ce"
                    : "#e2e8f0"
                  : "transparent",
                borderRadius: "4px",
                marginBottom: 2,
              }}
            >
              <Checkbox
                size="small"
                checked={checked}
                onChange={() => toggle(opt)}
              />
              <span
                style={{
                  marginLeft: 8,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {opt}
              </span>
            </div>
          );
        })}
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button
          onClick={clear}
          style={{
            padding: "6px 12px",
            backgroundColor: isDarkTheme ? "#4a5568" : "#e2e8f0",
            color: isDarkTheme ? "#f7fafc" : "#2d3748",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          Clear
        </button>
        <button
          onClick={apply}
          style={{
            padding: "6px 12px",
            backgroundColor: "#0969da",
            color: "white",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          Apply
        </button>
      </div>
    </div>
  );
});

// Custom checkbox filter for 'tag_name' column (Tags)
const TagsFilter = React.forwardRef<any, any>((params, ref) => {
  const [selected, setSelected] = useState<string[]>([]);
  const [isAll, setIsAll] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const [options, setOptions] = useState<string[]>(
    Array.isArray(params.tagsOptions) ? params.tagsOptions : []
  );

  const filteredOptions = useMemo(() => {
    const opts = options || [];
    if (!searchText.trim()) return opts;
    return opts.filter((o) =>
      o.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [options, searchText]);

  useEffect(() => {
    if (Array.isArray(params.tagsOptions)) setOptions(params.tagsOptions);
  }, [params.tagsOptions]);

  React.useImperativeHandle(ref, () => ({
    isFilterActive: () => selected.length > 0 && !isAll,
    doesFilterPass: (nodeParams: any) => {
      if (selected.length === 0 || isAll) return true;
      const tagString: string = nodeParams.data?.tag_name || "";
      const tagsArray = tagString
        .split(",")
        .map((t) => t.trim().toUpperCase())
        .filter(Boolean);
      const wanted = selected.map((s) => String(s).toUpperCase().trim());
      return wanted.some((w) => tagsArray.includes(w));
    },
    getModel: () =>
      selected.length > 0 && !isAll ? { selectedTypes: selected } : null,
    setModel: (model: any) => {
      if (model && model.selectedTypes) {
        setSelected(model.selectedTypes);
        setIsAll(false);
      } else {
        setSelected([]);
        setIsAll(true);
      }
    },
    getGui: () => null,
  }));

  const toggle = (opt: string) => {
    if (opt === "All") {
      setIsAll(true);
      setSelected([]);
    } else {
      setIsAll(false);
      setSelected((prev) =>
        prev.includes(opt) ? prev.filter((o) => o !== opt) : [...prev, opt]
      );
    }
    // @ts-ignore mark modified if available
    if (typeof (params as any).filterModifiedCallback === "function")
      (params as any).filterModifiedCallback();
  };

  const apply = () => {
    console.log("TagsFilter Apply clicked", { selected, isAll });
    try {
      if (typeof (params as any).onApplyTagsFilter === "function") {
        (params as any).onApplyTagsFilter(selected, isAll);
      }
    } catch {}
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === "function")
      (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const clear = () => {
    setSelected([]);
    setIsAll(true);
    try {
      if (typeof (params as any).onApplyTagsFilter === "function") {
        (params as any).onApplyTagsFilter([], true);
      }
    } catch {}
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === "function")
      (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const isDarkTheme = params.isDarkMode || false;

  return (
    <div
      style={{
        padding: "12px",
        minWidth: "180px",
        backgroundColor: isDarkTheme ? "#2d3748" : "#ffffff",
        border: `1px solid ${isDarkTheme ? "#4a5568" : "#e2e8f0"}`,
        borderRadius: "6px",
        boxShadow: isDarkTheme
          ? "0 4px 6px rgba(0, 0, 0, 0.3)"
          : "0 4px 6px rgba(0, 0, 0, 0.1)",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        fontSize: "13px",
      }}
    >
      <div
        style={{
          marginBottom: "12px",
          fontWeight: 500,
          color: isDarkTheme ? "#f7fafc" : "#2d3748",
          fontSize: "13px",
        }}
      >
        Filter Tags
      </div>
      <div style={{ marginBottom: "12px" }}>
        <input
          type="text"
          placeholder="Search..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{
            width: "100%",
            padding: "6px 8px",
            border: `1px solid ${isDarkTheme ? "#4a5568" : "#e2e8f0"}`,
            borderRadius: "4px",
            backgroundColor: isDarkTheme ? "#1a202c" : "#ffffff",
            color: isDarkTheme ? "#f7fafc" : "#2d3748",
            fontSize: "13px",
            outline: "none",
            boxSizing: "border-box",
          }}
        />
      </div>
      <div className="scroll"
        style={{ maxHeight:220, overflowY: "auto", marginBottom: "12px" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0px 8px",
            cursor: "pointer",
            backgroundColor: isAll
              ? isDarkTheme
                ? "#3182ce"
                : "#e2e8f0"
              : "transparent",
            borderRadius: "4px",
            marginBottom: "2px",
          }}
        >
          <Checkbox
            size="small"
            checked={isAll}
            onChange={() => toggle("All")}
          />
          <span style={{ marginLeft: 8 }}>All</span>
        </div>
        {filteredOptions.map((opt) => {
          const checked = !isAll && selected.includes(opt);
          return (
            <div
              key={opt}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "0px 8px",
                cursor: "pointer",
                backgroundColor: checked
                  ? isDarkTheme
                    ? "#3182ce"
                    : "#e2e8f0"
                  : "transparent",
                borderRadius: "4px",
                marginBottom: 2,
              }}
            >
              <Checkbox
                size="small"
                checked={checked}
                onChange={() => toggle(opt)}
              />

              <WhiteTooltip title={opt}>
                <span
                  style={{
                    marginLeft: 8,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: 150,
                    display: "inline-block",
                    cursor: "pointer",
                  }}
                >
                  {opt}
                </span>
              </WhiteTooltip>
            </div>
          );
        })}
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button
          onClick={clear}
          style={{
            padding: "6px 12px",
            backgroundColor: isDarkTheme ? "#4a5568" : "#e2e8f0",
            color: isDarkTheme ? "#f7fafc" : "#2d3748",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          Clear
        </button>
        <button
          onClick={apply}
          style={{
            padding: "6px 12px",
            backgroundColor: "#0969da",
            color: "white",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          Apply
        </button>
      </div>
    </div>
  );
});

// Custom checkbox filter for 'control_type' column (Benchmark)
const ControlTypeFilter = React.forwardRef<any, any>((params, ref) => {
  const [selected, setSelected] = useState<string[]>([]);
  const [isAll, setIsAll] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const [options, setOptions] = useState<string[]>(
    Array.isArray(params.controlTypeOptions) ? params.controlTypeOptions : []
  );

  const filteredOptions = useMemo(() => {
    const opts = options || [];
    if (!searchText.trim()) return opts;
    return opts.filter((o) =>
      o.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [options, searchText]);

  useEffect(() => {
    if (Array.isArray(params.controlTypeOptions))
      setOptions(params.controlTypeOptions);
  }, [params.controlTypeOptions]);

  React.useImperativeHandle(ref, () => ({
    isFilterActive: () => selected.length > 0 && !isAll,
    doesFilterPass: (nodeParams: any) => {
      if (selected.length === 0 || isAll) return true;
      const val = nodeParams.data?.control_type;
      if (val == null) return false;
      const rowUpper = String(val).toUpperCase().trim();
      return selected.some((s) => rowUpper === String(s).toUpperCase().trim());
    },
    getModel: () =>
      selected.length > 0 && !isAll ? { selectedTypes: selected } : null,
    setModel: (model: any) => {
      if (model && model.selectedTypes) {
        setSelected(model.selectedTypes);
        setIsAll(false);
      } else {
        setSelected([]);
        setIsAll(true);
      }
    },
    getGui: () => null,
  }));

  const toggle = (opt: string) => {
    if (opt === "All") {
      setIsAll(true);
      setSelected([]);
    } else {
      setIsAll(false);
      setSelected((prev) =>
        prev.includes(opt) ? prev.filter((o) => o !== opt) : [...prev, opt]
      );
    }
    // @ts-ignore
    if (typeof (params as any).filterModifiedCallback === "function")
      (params as any).filterModifiedCallback();
  };

  const apply = () => {
    console.log("ControlTypeFilter Apply clicked", { selected, isAll });
    try {
      if (typeof (params as any).onApplyControlTypeFilter === "function") {
        (params as any).onApplyControlTypeFilter(selected, isAll);
      }
    } catch {}
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === "function")
      (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const clear = () => {
    setSelected([]);
    setIsAll(true);
    try {
      if (typeof (params as any).onApplyControlTypeFilter === "function") {
        (params as any).onApplyControlTypeFilter([], true);
      }
    } catch {}
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === "function")
      (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const isDarkTheme = params.isDarkMode || false;

  return (
    <div
      style={{
        padding: "12px",
        minWidth: "240px",
        backgroundColor: isDarkTheme ? "#2d3748" : "#ffffff",
        border: `1px solid ${isDarkTheme ? "#4a5568" : "#e2e8f0"}`,
        borderRadius: "6px",
        boxShadow: isDarkTheme
          ? "0 4px 6px rgba(0, 0, 0, 0.3)"
          : "0 4px 6px rgba(0, 0, 0, 0.1)",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        fontSize: "13px",
      }}
    >
      <div
        style={{
          marginBottom: "12px",
          fontWeight: 500,
          color: isDarkTheme ? "#f7fafc" : "#2d3748",
          fontSize: "13px",
        }}
      >
        Filter Benchmarks
      </div>
      <div style={{ marginBottom: "12px" }}>
        <input
          type="text"
          placeholder="Search..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{
            width: "100%",
            padding: "6px 8px",
            border: `1px solid ${isDarkTheme ? "#4a5568" : "#e2e8f0"}`,
            borderRadius: "4px",
            backgroundColor: isDarkTheme ? "#1a202c" : "#ffffff",
            color: isDarkTheme ? "#f7fafc" : "#2d3748",
            fontSize: "13px",
            outline: "none",
            boxSizing: "border-box",
          }}
        />
      </div>
      <div
        style={{ maxHeight: "200px", overflowY: "auto", marginBottom: "12px" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "6px 8px",
            cursor: "pointer",
            backgroundColor: isAll
              ? isDarkTheme
                ? "#3182ce"
                : "#e2e8f0"
              : "transparent",
            borderRadius: "4px",
            marginBottom: "2px",
          }}
        >
          <Checkbox
            size="small"
            checked={isAll}
            onChange={() => toggle("All")}
          />
          <span style={{ marginLeft: 8 }}>All</span>
        </div>
        {filteredOptions.map((opt) => {
          const checked = !isAll && selected.includes(opt);
          return (
            <div
              key={opt}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "1px 8px",
                cursor: "pointer",
                backgroundColor: checked
                  ? isDarkTheme
                    ? "#3182ce"
                    : "#e2e8f0"
                  : "transparent",
                borderRadius: "4px",
                marginBottom: 2,
              }}
            >
              <Checkbox
                size="small"
                checked={checked}
                onChange={() => toggle(opt)}
              />
              <span style={{ marginLeft: 8 }}>{opt}</span>
            </div>
          );
        })}
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button
          onClick={clear}
          style={{
            padding: "6px 12px",
            backgroundColor: isDarkTheme ? "#4a5568" : "#e2e8f0",
            color: isDarkTheme ? "#f7fafc" : "#2d3748",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          Clear
        </button>
        <button
          onClick={apply}
          style={{
            padding: "6px 12px",
            backgroundColor: "#0969da",
            color: "white",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          Apply
        </button>
      </div>
    </div>
  );
});

// Custom checkbox filter for 'severity' column
const SeverityFilter = React.forwardRef<any, any>((params, ref) => {
  const [selected, setSelected] = useState<string[]>([]);
  const [isAll, setIsAll] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const [options, setOptions] = useState<string[]>(
    Array.isArray(params.severityOptions) ? params.severityOptions : []
  );

  const filteredOptions = useMemo(() => {
    const opts = options || [];
    if (!searchText.trim()) return opts;
    return opts.filter((o) =>
      o.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [options, searchText]);

  useEffect(() => {
    if (Array.isArray(params.severityOptions))
      setOptions(params.severityOptions);
  }, [params.severityOptions]);

  React.useImperativeHandle(ref, () => ({
    isFilterActive: () => selected.length > 0 && !isAll,
    doesFilterPass: (nodeParams: any) => {
      if (selected.length === 0 || isAll) return true;
      const val = nodeParams.data?.severity;
      if (val == null) return false;
      const rowUpper = String(val).toUpperCase().trim();
      return selected.some((s) => rowUpper === String(s).toUpperCase().trim());
    },
    getModel: () =>
      selected.length > 0 && !isAll ? { selectedTypes: selected } : null,
    setModel: (model: any) => {
      if (model && model.selectedTypes) {
        setSelected(model.selectedTypes);
        setIsAll(false);
      } else {
        setSelected([]);
        setIsAll(true);
      }
    },
    getGui: () => null,
  }));

  const toggle = (opt: string) => {
    if (opt === "All") {
      setIsAll(true);
      setSelected([]);
    } else {
      setIsAll(false);
      setSelected((prev) =>
        prev.includes(opt) ? prev.filter((o) => o !== opt) : [...prev, opt]
      );
    }
    // @ts-ignore
    if (typeof (params as any).filterModifiedCallback === "function")
      (params as any).filterModifiedCallback();
  };

  const apply = () => {
    console.log("SeverityFilter Apply clicked", { selected, isAll });
    try {
      if (typeof (params as any).onApplySeverityFilter === "function") {
        (params as any).onApplySeverityFilter(selected, isAll);
      }
    } catch {}
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === "function")
      (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const clear = () => {
    setSelected([]);
    setIsAll(true);
    try {
      if (typeof (params as any).onApplySeverityFilter === "function") {
        (params as any).onApplySeverityFilter([], true);
      }
    } catch {}
    // @ts-ignore
    if (typeof (params as any).filterChangedCallback === "function")
      (params as any).filterChangedCallback();
    else params.api?.onFilterChanged?.();
    // @ts-ignore
    params.api?.hidePopupMenu?.();
  };

  const isDarkTheme = params.isDarkMode || false;

  return (
    <div
      style={{
        padding: "12px",
        minWidth: "240px",
        backgroundColor: isDarkTheme ? "#2d3748" : "#ffffff",
        border: `1px solid ${isDarkTheme ? "#4a5568" : "#e2e8f0"}`,
        borderRadius: "6px",
        boxShadow: isDarkTheme
          ? "0 4px 6px rgba(0, 0, 0, 0.3)"
          : "0 4px 6px rgba(0, 0, 0, 0.1)",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        fontSize: "13px",
      }}
    >
      <div
        style={{
          marginBottom: "12px",
          fontWeight: 500,
          color: isDarkTheme ? "#f7fafc" : "#2d3748",
          fontSize: "13px",
        }}
      >
        Filter Severity
      </div>
      <div style={{ marginBottom: "12px" }}>
        <input
          type="text"
          placeholder="Search..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{
            width: "100%",
            padding: "6px 8px",
            border: `1px solid ${isDarkTheme ? "#4a5568" : "#e2e8f0"}`,
            borderRadius: "4px",
            backgroundColor: isDarkTheme ? "#1a202c" : "#ffffff",
            color: isDarkTheme ? "#f7fafc" : "#2d3748",
            fontSize: "13px",
            outline: "none",
            boxSizing: "border-box",
          }}
        />
      </div>
      <div
        style={{ maxHeight: "200px", overflowY: "auto", marginBottom: "12px" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0px 8px",
            cursor: "pointer",
            backgroundColor: isAll
              ? isDarkTheme
                ? "#3182ce"
                : "#e2e8f0"
              : "transparent",
            borderRadius: "4px",
            marginBottom: "2px",
          }}
        >
          <Checkbox
            size="small"
            checked={isAll}
            onChange={() => toggle("All")}
          />
          <span style={{ marginLeft: 8 }}>All</span>
        </div>
        {filteredOptions.map((opt) => {
          const checked = !isAll && selected.includes(opt);
          return (
            <div
              key={opt}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "0px 8px",
                cursor: "pointer",
                backgroundColor: checked
                  ? isDarkTheme
                    ? "#3182ce"
                    : "#e2e8f0"
                  : "transparent",
                borderRadius: "4px",
                marginBottom: 2,
              }}
            >
              <Checkbox
                size="small"
                checked={checked}
                onChange={() => toggle(opt)}
              />
              <span style={{ marginLeft: 8 }}>{opt}</span>
            </div>
          );
        })}
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button
          onClick={clear}
          style={{
            padding: "6px 12px",
            backgroundColor: isDarkTheme ? "#4a5568" : "#e2e8f0",
            color: isDarkTheme ? "#f7fafc" : "#2d3748",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          Clear
        </button>
        <button
          onClick={apply}
          style={{
            padding: "6px 12px",
            backgroundColor: "#0969da",
            color: "white",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          Apply
        </button>
      </div>
    </div>
  );
});

const SecurityInformation = () => {
  // const { scan_uuid } = useParams<{ scan_uuid: string }>();
  const [isRowClick, setIsRowClick] = useState(false);
  const [rowData, setRowData] = useState<any[]>([]);
  const [gridData, setGridData] = useState<any[]>([]);
  const [selectedRow, setSelectedRow] = useState<any | null>(null);
  const [headerResponse, setHeaderResponse] = useState<any>(null);
  const [value, setValue] = React.useState(0);
  const [isDetailsTotalResources, setIsDetailsTotalResources] =
    useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [isReportDialogOpen, setIsReportDialogOpen] = useState(false);
  const [reportFormat, setReportFormat] = useState("excel");
  const [downloading, setDownloading] = useState(false);
  interface CreateTag {
    default?: string[];
    user?: string[];
  }
  const location = useLocation();
  let module = "";
  let downloadModule = "";
  //const location = useLocation();
  console.log(location.pathname, "location.pathname");
  if (location.pathname == "/on-premises/security-posture") {
    module = "on_premise";
    downloadModule = "on_premise";
  } else {
    module = "cloud";
    downloadModule = "cloud";
  }

  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  console.log(selectedRow, "selectedRow");
  console.log(headerResponse, "headerResponse");

  console.log(value);

  const handleDownloadClick = () => {
    setIsReportDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsReportDialogOpen(false);
  };

  const handleDownloadReport = () => {
    setDownloading(true);
    const payload = {
      report_format: reportFormat.toLowerCase(),
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      type: "org_posture",
      module: downloadModule,
      asset_ids:"1",
    };
    console.log(payload, "payload");

    axiosInstance
      .post(END_POINTS.REPORT_DOWNLOAD, payload)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Report request submitted, please check Reports section.");
        }
        setIsReportDialogOpen(false);
      })
      .catch((error) => {
        console.error("Error making API call:", error);
        toast.error("Failed to submit report request, please try again.");
      })
      .finally(() => {
        setIsReportDialogOpen(false);
        setDownloading(false);
      });
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsReady(false);
    try {
      let queryUrl = `securityscan/security-info?module=${module}`;
      if (location.state && (location.state as any).id && !(location.state as any).control_type) {
        queryUrl += `&pid=${(location.state as any).id}`;
      }
      if (location.state && (location.state as any).control_type) {
        queryUrl += `&control_type=${encodeURIComponent((location.state as any).control_type)}`;
      }
      const response = await axiosInstance.get(queryUrl);
      if (response.data?.data) {
        const formattedData = response.data.data.map((control: any) => ({
          id: control.id,
          type: `${control.param_name} - ${control.device_type}`,
          controls: `${control.param_name}`,
          asset_count: control.asset_count,
          compliance_passed_count: control.passed_asset_count,
          compliance_failed_count: control.compliance_failed_count,
          accepted_count: control.accepted_count,
          compliance_count: control.asset_passed_percent,
          tag_name: control.tag_name,
          parameter_type: control.parameter_type,
          is_manual: control.is_manual,
          severity: control.highest_priority,
          control_type: control.control_type,
          total_Count: control.total_asset_count,
          failed_asset_count: control.failed_asset_count,
          passed_asset_count: control.passed_asset_count,
          not_applicable_asset_count: control.not_applicable_asset_count,
        }));

        setRowData(formattedData);
        setGridData(formattedData);
        setIsReady(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setRowData([]);
    } finally {
      setIsLoading(false);
    }
  };

  //Scan Details API
  useEffect(() => {
    const handleFilterSaved = () => {
      setIsLoading(true);
      setRowData([]);
      fetchData();
    };

    eventEmitter.on("filterSaved", handleFilterSaved);
    return () => {
      eventEmitter.off("filterSaved", handleFilterSaved);
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, [module, location.state?.id, location.state?.control_type]);

  const dispatch = useDispatch();

  // Reset isReady when dependencies change
  useEffect(() => {
    setIsReady(false);
  }, [module]);

  // // Header Details API
  // const fetchControlDetails = () => {
  //   if (selectedRow) {
  //     axiosInstance
  //       .get(`securityscan/control-details/${selectedRow.id}`)
  //       .then((response) => {
  //         setHeaderResponse(response.data?.data);
  //         setIsCreateTags(response.data?.data?.tags);
  //       })
  //       .catch((error) => console.error("Error fetching details:", error));
  //   }
  // };

  // useEffect(() => {
  //   fetchControlDetails();
  // }, [selectedRow]);

  //Details >>  Total Resources APi
  useEffect(() => {
    if (selectedRow) {
      axiosInstance
        .get(
          `securityscan/control-asset-details/${selectedRow.id}?module=${module}`
        )
        .then((response) => setIsDetailsTotalResources(response.data))
        .catch((error) => console.error("Error fetching details:", error));
    }
  }, [selectedRow]);

  const Total_Resources = isDetailsTotalResources?.data;

  console.log(Total_Resources, "Total_Resources");

  const handleOnRowClick = (row: any) => {
    setSelectedRow(row);
    setIsRowClick(true);
    dispatch(setSelectedRowID(row.id));
    if (row?.control_type) {
      dispatch(setSelectedControlType(String(row.control_type)));
      dispatch(setButtonSelected(row.control_type.toLowerCase()));
    }
  };
    const agGridInlineStyles = useMemo(
      () => ({
        padding: "0px",
        // "& .ag-body-vertical-scroll": {
        //   width: "0px !important",
        //   minWidth: "0px !important",
        // },
        // "& .ag-body-vertical-scroll-viewport": {
        //   width: "0px !important",
        //   minWidth: "0px !important",
        // },
        "& .ag-center-cols-clipper": {
          marginRight: 0,
        },
        "& .ag-center-cols-viewport": {
          marginRight: 0,
        },
      }),
      []
    );

  const columnDefs: ColDef[] = [
    {
      field: "id",
      headerName: "#",
      minWidth: 80,
      maxWidth: 90,
      valueGetter: (params: any) => params.node.rowIndex + 1,
    },

    {
      field: "controls",
      headerName: "Recommendation",
      filter: ControlsFilter,
      filterParams: {
        parameterOptions: useMemo(() => {
          const set = new Set<string>();
          rowData.forEach((r: any) => {
            if (r?.parameter_type) set.add(String(r.parameter_type));
          });
          return Array.from(set);
        }, [rowData]),
        isDarkMode: isDarkMode,
        onApplyParameterFilter: (selected: string[], isAll: boolean) => {
          if (isAll || !selected || selected.length === 0) {
            setGridData(rowData);
            return;
          }
          const targets = selected.map((s) => String(s).toUpperCase().trim());
          const filtered = rowData.filter((r: any) =>
            targets.includes(String(r?.parameter_type).toUpperCase().trim())
          );
          setGridData(filtered);
        },
      },
      minWidth: 450,
      width: 450,
      flex: 1,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      cellRenderer: (params: any) => {
        const value = params.value || "";
        const parameterType = params.data?.parameter_type || "";
        const isManual = parameterType === "Manual";
        // const color = isManual ? "#F7941F" : "#696595";
        const color = isManual
          ? isDarkMode
            ? "#FFB74D"
            : "#F7941F"
          : isDarkMode
          ? "#B2B2FF"
          : "#696595";
        const bgcolor = isManual ? "#F7941F" : "#696595";

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: 8,
            }}
          >
            <Tooltip
              title={value}
              arrow
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#fff",
                    color: "#000",
                    border: "1px solid #e0e0e0",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                    fontSize: "0.775rem",
                  },
                },
                arrow: {
                  sx: {
                    color: "#fff",
                    "&::before": {
                      border: "1px solid #e0e0e0",
                    },
                  },
                },
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontWeight: "bold",
                  flex: 1,
                }}
              >
                {value}
              </Typography>
            </Tooltip>

            {parameterType && (
              <Chip
                label={parameterType}
                variant="outlined"
                size="small"
                sx={{
                  borderRadius: 1,
                  border: `1px solid ${bgcolor}`,
                  // bgcolor: "white",
                  color: color,
                  fontWeight: "bold",
                  ml: 1,
                }}
              />
            )}
          </div>
        );
      },
    },

    {
      field: "tag_name",
      headerName: "Tags",
      filter: TagsFilter,
      filterParams: {
        tagsOptions: useMemo(() => {
          const set = new Set<string>();
          rowData.forEach((r: any) => {
            const tagString: string = r?.tag_name || "";
            tagString
              .split(",")
              .map((t) => t.trim())
              .filter(Boolean)
              .forEach((t) => set.add(t));
          });
          return Array.from(set);
        }, [rowData]),
        isDarkMode: isDarkMode,
        onApplyTagsFilter: (selected: string[], isAll: boolean) => {
          if (isAll || !selected || selected.length === 0) {
            setGridData(rowData);
            return;
          }
          const wanted = selected.map((s) => String(s).toUpperCase().trim());
          const filtered = rowData.filter((r: any) => {
            const tagString: string = r?.tag_name || "";
            const tags = tagString
              .split(",")
              .map((t) => t.trim().toUpperCase())
              .filter(Boolean);
            return wanted.some((w) => tags.includes(w));
          });
          setGridData(filtered);
        },
      },
      minWidth: 240,
      cellRenderer: (params: any) => {
        const getRandomColor = () => {
          const hue = Math.floor(Math.random() * 360);
          return {
            background: `hsl(${hue}, 70%, 80%)`,
            color: `hsl(${hue}, 50%, 20%)`,
          };
        };

        const tagString = params.data?.tag_name;
        const tagsArray = tagString.split(",").map((tag: any) => tag.trim());

        const visibleTags = tagsArray.slice(0, 1);
        const hiddenTags = tagsArray.slice(1);

        // Capitalize first letter utility
        const capitalize = (str: string) =>
          str.charAt(0).toUpperCase() + str.slice(1);

        return (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
            {visibleTags.map((tag: string, index: number) => {
              // Apply specific styles to first and second tag
              let style = {};
              if (index === 0) {
                style = {
                  backgroundColor: "#0183191A",
                  color: "#018319",
                };
              } else if (index === 1) {
                style = {
                  backgroundColor: "#894B001A",
                  color: "#894B00",
                };
              } else {
                const random = getRandomColor();
                style = {
                  backgroundColor: random.background,
                  color: random.color,
                };
              }

              return (
                <Chip
                  key={index}
                  size="small"
                  label={capitalize(tag)}
                  style={{
                    ...style,
                    fontWeight: "bold",
                    borderRadius: 4,
                  }}
                />
              );
            })}

            {hiddenTags.length > 0 && (
              <Tooltip
                title={hiddenTags.join(", ")}
                placement="auto"
                arrow
                slotProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "#fff",
                      color: "#000",
                      border: "1px solid #e0e0e0",
                      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                      fontSize: "0.775rem",
                    },
                  },
                  arrow: {
                    sx: {
                      color: "#fff",
                      "&::before": {
                        border: "1px solid #e0e0e0",
                      },
                    },
                  },
                }}
              >
                <Chip
                  size="small"
                  variant="outlined"
                  label={`+${hiddenTags.length}`}
                  style={{
                    fontWeight: "bold",
                    borderRadius: 4,
                    border: "1px solid #BEBED1",
                  }}
                />
              </Tooltip>
            )}
          </div>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },

    {
      field: "control_type",
      headerName: "Benchmark",
      filter: ControlTypeFilter,
      filterParams: {
        controlTypeOptions: useMemo(() => {
          const set = new Set<string>();
          rowData.forEach((r: any) => {
            if (r?.control_type) set.add(String(r.control_type).toUpperCase());
          });
          return Array.from(set);
        }, [rowData]),
        isDarkMode: isDarkMode,
        onApplyControlTypeFilter: (selected: string[], isAll: boolean) => {
          if (isAll || !selected || selected.length === 0) {
            setGridData(rowData);
            return;
          }
          const targets = selected.map((s) => String(s).toUpperCase().trim());
          const filtered = rowData.filter((r: any) =>
            targets.includes(String(r?.control_type).toUpperCase().trim())
          );
          setGridData(filtered);
        },
      },
      minWidth: 150,
      width: 200,
      cellClass: "custom-cell",
      // cellRenderer: (params: any) => (
      //   <Box sx={{ display: "flex", alignItems: "center", gap: 1, pt: 1 }}>
      //     {params.value?.includes("SPARK") && (
      //       <img
      //         src={isDarkMode ? spark_dark : sparkLogo}
      //         alt="spark"
      //         height="24"
      //       />
      //     )}
      //     {params.value?.includes("CIS") && (
      //       <img
      //         src={isDarkMode ? cis_dark : cis_light}
      //         alt="cis"
      //         height="24"
      //       />
      //     )}
      //     {params.value?.includes("NIST") && (
      //       <img
      //         src={isDarkMode ? nist_dark : nistLogo}
      //         alt="nist"
      //         height="12"
      //       />
      //     )}
      //   </Box>
      // ),
      cellRenderer: (params: any) => {
        if (!params.value) return null;
        const rawParts: string[] = String(params.value)
          .split(",")
          .map((item: string) => item.trim())
          .filter(Boolean);

        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, pt: 1, flexWrap: "nowrap" }}>
            {rawParts.map((part: string, index: number) => {
              const partUpper = part.toUpperCase();
              const isSpark = partUpper === "SPARK" || (partUpper.startsWith("SPARK ") && !partUpper.startsWith("SPARK_"));
              const isCis = partUpper === "CIS" || (partUpper.startsWith("CIS ") && !partUpper.startsWith("CISCO"));
              const isNist = partUpper === "NIST" || partUpper.startsWith("NIST ");

              if (isSpark) return <img key={index} src={isDarkMode ? spark_dark : sparkLogo} alt="spark" height="24" />;
              if (isCis) return <img key={index} src={isDarkMode ? cis_dark : cis_light} alt="cis" height="24" />;
              if (isNist) return <img key={index} src={isDarkMode ? nist_dark : nistLogo} alt="nist" height="12" />;

              return (
                <Tooltip key={index} title={part} arrow placement="top">
                  <img
                    src={customTemplateLogo}
                    alt="Custom Template"
                    height="24"
                  />
                </Tooltip>
              );
            })}
          </Box>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },

    {
      field: "severity",
      headerName: "Severity",
      filter: SeverityFilter,
      filterParams: {
        severityOptions: useMemo(() => {
          const set = new Set<string>();
          rowData.forEach((r: any) => {
            if (r?.severity) set.add(String(r.severity).toUpperCase());
          });
          return Array.from(set);
        }, [rowData]),
        isDarkMode: isDarkMode,
        onApplySeverityFilter: (selected: string[], isAll: boolean) => {
          if (isAll || !selected || selected.length === 0) {
            setGridData(rowData);
            return;
          }
          const targets = selected.map((s) => String(s).toUpperCase().trim());
          const filtered = rowData.filter((r: any) =>
            targets.includes(String(r?.severity).toUpperCase().trim())
          );
          setGridData(filtered);
        },
      },
      minWidth: 150,
      width: 200,
      cellRenderer: (params: any) => {
        const severityStyles: any = {
          Critical: { bgcolor: isDarkMode ? "rgba(255, 61, 61, 0.18)" : "#67000424", color: isDarkMode ? "#FF3D3D" : "#670004" },
    High: { bgcolor: isDarkMode ? "rgba(255, 107, 107, 0.15)" : "#A7000F24", color: isDarkMode ? "#FF6B6B" : "#A7000F" },
    Medium: { bgcolor: isDarkMode ? "rgba(255, 167, 38, 0.15)" : "#E8580024", color: isDarkMode ? "#FFA726" : "#E85800" },
    Low: { bgcolor: isDarkMode ? "rgba(255, 224, 130, 0.15)" : "#F2BF0024", color: isDarkMode ? "#FFE082" : "#F2BF00" },
  };
        return (
          <Chip
            label={params.value}
            size="small"
            sx={{
              bgcolor: severityStyles[params.value]?.bgcolor || "#f5f5f5",
              color: severityStyles[params.value]?.color || "#666666",
              height: "20px",
              borderRadius: "4px",
              position: "relative",
              fontWeight: 600,
              p: 1.5,
              pr: 0,
              "&::before": {
                content: '""',
                position: "absolute",
                left: 8,
                top: "50%",
                transform: "translateY(-50%)",
                width: 8,
                height: 8,
                bgcolor: severityStyles[params.value]?.color || "#666666",
                borderRadius: "50%",
              },
              "& .MuiChip-label": { px: 1 },
            }}
          />
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "accepted_count",
      headerName: "Risk Accepted",
      filter: true,
      minWidth: 150,
      cellRenderer: (params: any) =>
        params.value > 0 ? (
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 1, pt: 1 }}
          >
            <img src={Exclamation} alt="exclamation" height="20" />
            <Typography>{params.value}</Typography>
          </Box>
        ) : (
          <img
            src={AcceptedRisk_False}
            alt="warning"
            style={{ height: "20px" }}
          />
        ),
    },

    {
      field: "compliance_count",
      headerName: module === "on_premise" ? "Assets" : "Resources",
      minWidth: 200,
      cellRenderer: (params: any) => {
        const passedCount = params.data.compliance_passed_count;
        const compliance_count = params.data.total_Count;
        const rawValue = params.value || 0;
        const data = params.data;
        const progressValue = Number(rawValue.toFixed(2));
        const STATUS_CONFIG = {
          passed_asset_count: { label: "Pass", icon: True },
          failed_asset_count: { label: "Fail", icon: False },
          not_applicable_asset_count: {
            label: "Not Applicable",
            icon: Not_Applicable,
          },
        };
        const availableStatuses = Object.entries(STATUS_CONFIG)
          .filter(([key]) => data[key] != null && data[key] > 0)
          .map(([key, config]) => ({
            ...config,
            count: data[key],
            key,
          }));

        const total = availableStatuses.reduce((sum, s) => sum + s.count, 0);
        const passed = data.passed_asset_count || 0;
        const passPercent =
          total > 0 ? ((passed / total) * 100).toFixed(2) : "0.00";

        const tooltipContent =
          availableStatuses.length > 0 ? (
            <Box sx={{ p: 1, width: 200 }}>
              {availableStatuses.map((status) => (
                <Box
                  key={status.key}
                  sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
                >
                  <img
                    src={status.icon}
                    alt={status.label}
                    style={{ width: 20, height: 20 }}
                  />
                  <Typography
                    variant="body2"
                    fontWeight={500}
                    sx={{ flexGrow: 1, color: "#000" }}
                  >
                    {status.label}
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ color: "#000" }}>
                    {status.count}
                  </Typography>
                </Box>
              ))}
            </Box>
          ) : (
            <Box sx={{ p: 1 }}>
              <Typography variant="body2" sx={{ color: "#000" }}>No data available</Typography>
            </Box>
          );

        return (
          <Tooltip
            title={tooltipContent}
            arrow
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#fff",
                  color: "#000",
                  border: "1px solid #e0e0e0",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                  fontSize: "0.775rem",
                },
              },
              arrow: {
                sx: {
                  color: "#fff",
                  "&::before": {
                    border: "1px solid #e0e0e0",
                  },
                },
              },
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 0.5,
                }}
              >
                <Typography variant="caption">
                  {`${passedCount}/${compliance_count} (${progressValue}%)`}
                </Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={progressValue}
                sx={{
                  height: 6,
                  borderRadius: 3,
                  bgcolor: "#f5f5f5",
                  "& .MuiLinearProgress-bar": {
                    bgcolor:
                      progressValue >= 70
                        ? "#4caf50"
                        : progressValue >= 40
                        ? "#ff9800"
                        : "#f44336",
                  },
                }}
              />
            </Box>
          </Tooltip>
        );
      },
    },
  ];

  const getSeverityStyle = (severity: string) => {
    switch (severity?.toLowerCase()) {
      case "low":
        return { color: "#F2BF00", backgroundColor: "#F2BF0024" };
      case "high":
        return { color: "#A7000F", backgroundColor: "#A7000F24" };
      case "critical":
        return { color: "#670004", backgroundColor: "#67000424" };
      case "medium":
        return { color: "#E85800", backgroundColor: "#E8580024" };
      default:
        return { color: "gray", backgroundColor: "#E0E0E0" };
    }
  };
  const Chipstyle = getSeverityStyle(headerResponse?.severity);

  const TypeChipColor = (type: string) => {
    switch (type) {
      case "Manual":
        return { color: "#2B335F", bgcolor: "#DEDDF2" };
      case "Automated":
        return { color: "#0B3D2E", bgcolor: "#CFF3E0" };
      default:
        return { color: "#000", bgcolor: "#E0E0E0" }; // fallback color
    }
  };

  const getTagStyle = (tag: string) => {
    switch (tag?.toLowerCase()) {
      case "ssh":
        return { color: "#018319", backgroundColor: "#0183191A" }; // Red tones
      case "https":
        return { color: "#894B00", backgroundColor: "#894B001A" }; // Green tones
      case "authentication":
        return { color: "#0485C2", backgroundColor: "#0485C21A" }; // Blue tones
      default:
        return { color: "gray", backgroundColor: "#E0E0E0" }; // Default gray
    }
  };

  const getStyledTag = (tag: string, index: number) => {
    const styles = [
      { color: "#018319", backgroundColor: "#0183191A" }, // green
      { color: "#894B00", backgroundColor: "#894B001A" }, // brown
      { color: "#0485C2", backgroundColor: "#0485C21A" },
      { color: "#3A2ADA", backgroundColor: "#1103C014" }, // blue
      // blue
      { color: "gray", backgroundColor: "#E0E0E0" }, // gray
    ];

    const style = styles[index] || {
      color: "black",
      backgroundColor: "#f0f0f0",
    };
    return (
      <Chip
        key={index}
        label={tag}
        style={style}
        sx={{ borderRadius: 1, fontWeight: "bold" }}
        size="small"
      />
    );
  };

  // Show user-created tags first so newly created tags appear at the top
  const allTags = [
    ...(headerResponse?.tags?.user || []),
    ...(headerResponse?.tags?.default || []),
  ];

  const visibleTags = allTags.slice(0, 3);
  const hiddenTags = allTags.slice(3);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => {
    setIsHovered(false);
    setIsClicked(false); // Optional: reset clicked on mouse leave
  };

  const getImage = () => {
    if (isHovered || open) return Pencil_Blue;
    return Pencil_Light_img;
  };

  const NoRowsOverlay = () => (
    <Box sx={{ p: 4, textAlign: "center", color: "#8787AE", fontWeight: 600 }}>
      No Rows to Show
    </Box>
  );

  return (
    <>
      <Card
        variant="outlined"
        sx={{ height: "calc(100vh - 103px)", borderRadius: 3 }}
      >
        <AgGridTable
          columnDefs={columnDefs}
          data={gridData || rowData}
          styles={agGridInlineStyles}
          showSearch
          isRowSelectable
          height={"calc(100vh - 144px)"}
          onRowClick={handleOnRowClick}
          isLoading={!isReady || isLoading}
          headerActions={
            <IconButton
              size="small"
              onClick={handleDownloadClick}
              sx={{ "&:focus": { outline: "none" } }}
            >
              <DownloadIcon sx={{ fontSize: 20 }} />
            </IconButton>
          }
        />
      </Card>
      <SecurityDetailsDrawer
        open={isRowClick}
        onClose={() => {
          setIsRowClick(false);
        }}
        row={selectedRow}
        module={module}
        selectedRow={selectedRow}
        fetchData={fetchData}
        // fetchControlDetails={fetchControlDetails}
      />

      {/* Download Report Dialog */}
      <Dialog
        open={isReportDialogOpen}
        onClose={handleDialogClose}
        sx={{
          "& .MuiDialog-paper": {
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "360px",
            height: "300px",
            borderRadius: "4px",
            transform: "translate(-50%, -50%)",
            padding: "10px",
            boxSizing: "border-box",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "16px",
            color: isDarkMode ? "#ffffff" : "#101828",
          }}
        >
          Download Org Posture Report?
        </DialogTitle>
        <DialogContent
          sx={{
            textAlign: "center",
            fontWeight: 400,
            fontSize: "14px",
            color: isDarkMode ? "#b0b0b0" : "#667085",
            overflow: "visible",
            maxHeight: "none",
          }}
        >
          <Typography variant="body2" sx={{ mb: 2, color: isDarkMode ? "#b0b0b0" : "#666666" }}>
            This report offers a comprehensive summary of your Organization data
          </Typography>
          <Typography
            variant="body2"
            fontWeight={500}
            align="center"
            sx={{ mb: 2, fontWeight: "bold" }}
          >
            Report Format
          </Typography>
          <RadioGroup
            value={reportFormat}
            onChange={(e) => setReportFormat(e.target.value)}
            row
            sx={{ justifyContent: "center" }}
          >
            <FormControlLabel value="excel" control={<Radio />} label="Excel" />
            <FormControlLabel value="pdf" control={<Radio disabled />} label="Pdf" />
          </RadioGroup>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            paddingBottom: "24px",
          }}
        >
          <Button
            onClick={handleDialogClose}
            variant="outlined"
            sx={{ width: 130 }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDownloadReport}
            variant="contained"
            disabled={downloading}
            color="primary"
            sx={{ width: 130 }}
          >
            {downloading ? (
              <Box display="flex" alignItems="center" gap={1}>
                <CircularProgress size={10} sx={{ color: "white" }} />
                <Typography sx={{ color: "white", fontSize: "11px" }}>
                  Downloading...
                </Typography>
              </Box>
            ) : (
              "Download"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SecurityInformation;
